import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

const itemKey = '_code_user_collapse';

/* Action types and creators */

export const { Types, Creators } = createActions({
  collapseSidebar: []
});

/* Reducer handlers */

const getItemValue = () => {
  const item = localStorage.getItem(itemKey);

  if (!item || item === null) {
    return { collapsed: false, };
  }

  return JSON.parse(item);
};

const INITIAL_STATE = Immutable({ ...getItemValue() });

const collapseSidebar = (state = INITIAL_STATE) => {
  const collapsed = !state.collapsed;
  const item = { collapsed };

  localStorage.setItem(itemKey, JSON.stringify(item));

  return { ...state, collapsed };
};

export default createReducer(INITIAL_STATE, {
  [Types.COLLAPSE_SIDEBAR]: collapseSidebar
});
